<template lang="pug">
v-card(flat)(v-if="conferences.length")
  .d-flex.flex-nowrap
    h3.text-body-1: strong Трансляции
    .grey--text.caption.ml-2 {{ conferences.length }}
    v-btn.ml-auto(
      icon
      color="primary"
      :disabled="conferenceIdx === 0"
      @click="conferenceIdx -= 1"
    ): v-icon(size="18") mdi-chevron-left
    v-btn(
      icon
      color="primary"
      :disabled="conferenceIdx === conferences.length - 1"
      @click="conferenceIdx += 1"
    ): v-icon(size="18") mdi-chevron-right

  v-slide-x-transition(hide-on-leave)
    lesson-meeting-card(
      :meeting="selectedConference"
    )
      //- v-list-item-action: v-icon(color="primary" label) $telegram

  //- v-list-item.mx-n2.px-2.mb-2.py-2(
  //-   style="min-height: 0"
  //-   :href="selectedConference.link"
  //- )
  //-   v-list-item-title.primary--text: strong Расписание
  //-   v-list-item-icon.ma-0: v-icon(color="primary") mdi-arrow-right

</template>
<script>
import { format, isAfter } from 'date-fns';

import LessonMeetingCard from './Lessons/LessonMeetingCard.vue';

export default {
  components: {
    LessonMeetingCard,
  },
  props: {
    course: { type: Object, required: true },
    group: { type: Object, required: true },
  },
  data() {
    return {
      conferences: [],
      conferenceIdx: 0,
      selectedConference: {},
    };
  },
  watch: {
    conferenceIdx(val) {
      this.selectedConference = this.conferences[val];
    },
  },
  async created() {
    await this.fetchTranslations('course_id', this.course.id);
    await this.fetchTranslations('group_id', this.group.id);
  },
  methods: {
    conferencePrefix(startDate) {
      return !isAfter(new Date(), new Date(`${startDate}Z`)) ? 'Начало:' : ' Началось';
    },
    async fetchTranslations(searchName, searchVal) {
      const query = {
        sort: 'date_start',
        'search[from_date]': format(new Date(), 'yyyy-MM-dd'),
        [`search[${searchName}]`]: searchVal,
      };
      query['search[im_learning]'] = true;
      const { items } = await this.$api.telegram.conferenceIndex(query);
      // const jazz = await this.$api.schedule.index({ ...query, expand: 'lesson,meeting' });
      const confirences = items.filter(({ date_end: dateEnd }) => {
        const result = isAfter(new Date(), new Date(`${dateEnd}Z`));
        return !result;
      });
      this.conferences.push(...confirences);
      if (this.conferences.length) [this.selectedConference] = this.conferences;
    },
  },
};
</script>
